import { p, status } from '@/plugins/permission'

export default {
  edit: {
    permission: [p.schoolManage],
    permissionList: status.permission,
    focus: true
  }
}
